import { render } from "./slice.vue?vue&type=template&id=48024f96&scoped=true"
import script from "./slice.vue?vue&type=script&lang=js"
export * from "./slice.vue?vue&type=script&lang=js"

import "./slice.vue?vue&type=style&index=0&id=48024f96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48024f96"],['__file',"src/js/components/slice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48024f96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48024f96', __exports__)) {
    api.reload('48024f96', __exports__)
  }
  
  module.hot.accept("./slice.vue?vue&type=template&id=48024f96&scoped=true", () => {
    api.rerender('48024f96', render)
  })

}


export default __exports__